import { refreshNativeLayer } from './refreshNativeLayer.js';

export function refreshNativeEvent() {
  refreshNativeLayer(this);
}
